const Consts = {
    voteStatus:{
        pending:1,
        start:2,
        concluded:3,
        netError:4,
    }
}

export default Consts;